import React from 'react';
import loaderGif from "../../../../../assets/images/loader.gif";

const DealsTable = ({ tableData, onSort, loader, onViewDetail, firstDate, secondDate }) => {
  const handleSort = (column) => {
    onSort(column);
  };

  const formatUsd = (value) => {
    if (value === null || value === undefined || value === '') return '-';
    const amount = Number(value);
    if (Number.isNaN(amount)) return '-';
    return amount.toLocaleString('en-US', {
      currency: 'USD',
      currencyDisplay: 'symbol',
      style: 'currency',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };

  const displayData = tableData || [];

  return (
    <>
      <div className="table-responsive custom-table">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th className="partner" onClick={() => handleSort('supply_partner_name')}>Supply Partner <i className="fas fa-sort"></i></th>
              <th className="partner" onClick={() => handleSort('demand_partner_name')}>Demand Partner <i className="fas fa-sort"></i></th>
              <th className="partner" onClick={() => handleSort('country_name')}>Country <i className="fas fa-sort"></i></th>
              <th className="deal-name" onClick={() => handleSort('deal_name')}>Deal Name <i className="fas fa-sort"></i></th>
              <th className='wrap-string partner' onClick={() => handleSort('first_revenue')}>{firstDate || 'First Date'} Advertiser cost <i className="fas fa-sort"></i></th>
              <th className='margin' onClick={() => handleSort('second_revenue')}>{secondDate || 'Second Date'} Advertiser cost <i className="fas fa-sort"></i></th>
              <th className='text-center'>Action</th>
            </tr>
          </thead>
          {!loader ?
            <tbody>
              {displayData.length > 0 ? (
                displayData.map((item, i) => {
                  const isLastRow = i === displayData.length - 1;
                  return (
                    <tr
                      key={i}
                      style={isLastRow ? { backgroundColor: '#e7f5ff', fontWeight: 700, color: '#0c63e4' } : undefined}
                    >
                      <td>{isLastRow ? '' : i + 1}</td>
                      <td className="wrap-string partner">{isLastRow ? 'Total' : item?.supply_partner_name || '-'}</td>
                      <td className="wrap-string partner">{isLastRow ? '-' : item?.demand_partner_name || '-'}</td>
                      <td className="wrap-string partner">{isLastRow ? '-' : item?.country || '-'}</td>
                      <td className="wrap-string deal-name">{isLastRow ? '-' : item?.deal_name || '-'}</td>
                      <td className="text-end partner">{formatUsd(item?.first_revenue)}</td>
                      <td className="text-end partner">{formatUsd(item?.second_revenue)}</td>
                      <td className="text-center">
                        {!isLastRow && (
                          <i className="fa-regular fa-eye blue" onClick={() => onViewDetail(item)} style={{cursor: 'pointer', fontSize: '1.2rem'}} aria-label="View Details" title="View Details"></i>
                        )}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
            :
            <tbody>
              <tr>
                <td colSpan="8" className="text-center py-5">
                  <div className={`loader ${loader ? 'show' : ''}`}>
                    <label>
                      <img src={loaderGif} alt="Loading" />
                    </label>
                  </div>
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
    </>
  );
};

export default DealsTable;
